(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["longevity-home-launch"]) return;
  try {
    
function setupLongevityReviews(scope) {
  scope.querySelectorAll('.llc-review-slider').forEach(slider => {
    if (slider.dataset.ready) return;
    slider.dataset.ready = 'true';
    const track = slider.querySelector('.llc-review-track');
    const buttons = slider.querySelectorAll('[data-review-direction]');
    const update = () => buttons.forEach(button => {
      const dir = Number(button.dataset.reviewDirection);
      button.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    });
    buttons.forEach(button => button.addEventListener('click', () => {
      const card = track.querySelector('.llc-review-card');
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
      track.scrollBy({left: Number(button.dataset.reviewDirection) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    track.addEventListener('scroll', update, {passive:true});
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupLongevityReviews(document));
else setupLongevityReviews(document);
document.addEventListener('shopify:section:load', event => setupLongevityReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
